import { Child } from '@/families/models/child';

/**
 * Utility functions for family exports.
 */
export class FamilyExportUtils {
    /**
     * Get the export button label that appears on the child table in the Family Hub.
     *
     * @param child
     */
    static getExportButtonLabel(child: Child): string {
        return child.export_failed ? 'Re-Export' : 'Export';
    }
}
